import { useApolloClient } from '@apollo/client'
import { Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import clsx from 'clsx'
import { motion } from 'framer-motion'
import React, { useEffect } from 'react'
import { InjuryProvider } from '../../providers/InjurySimulation'
import { SliderProvider } from '../../providers/SliderSimulation'
import { useWorkspace } from '../../providers/workspace'
import { CartButton } from '../CartButton/CartButton'
import DoctorCard from '../DoctorCard'
import Drawing from '../Draw'
import FloatingMenu from '../FloatingMenu'
import {
  animationAppTransitions,
  animationAppVariants
} from '../Helpers/pageAnimation'
import SideMenu from '../SideMenu'
import { useDoctorCard } from './useDoctorCard'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    overflow: 'hidden',
    background: 'linear-gradient(180deg, #CBCBCB 0%, #666666 143.29%)'
  },
  container: {
    flexGrow: 1,
    position: 'relative',
    overflow: 'hidden'
  },
  content: {
    height: 'auto',
    width: 'auto',
    position: 'relative',
    overflow: 'auto'
  },
  contentDrawing: {
    overflow: 'hidden',
    touchAction: 'none'
  },
  closeMenu: {
    '&.MuiButtonBase-root': {
      position: 'fixed',
      left: 0,
      top: 0,
      display: 'flex',
      height: '100vh',
      width: 40,
      minWidth: 40,
      justifyContent: 'center',
      alignItems: 'center',
      color: '#fff',
      cursor: 'pointer',
      borderRadius: 0,
      zIndex: 100,
      outline: 0,
      background:
        'linear-gradient(180deg, rgba(51, 51, 51, 0.2) 0%, #333333 100%), linear-gradient(197.24deg, #46A4E0 0%, #246193 98.81%)'
    }
  }
}))

const AppLayout: React.FC = ({ children }) => {
  const classes = useStyles()
  const [open, setOpen] = React.useState(true)
  const [drawing, setDrawing] = React.useState(false)
  const { selectedWorkspace } = useWorkspace(({ selectedWorkspace }) => ({
    selectedWorkspace
  }))

  const {
    loading: doctorCardLoading,
    doctorCard,
    loadDoctorCard
  } = useDoctorCard()
  const client = useApolloClient()

  useEffect(() => {
    if (!selectedWorkspace) return
    loadDoctorCard(client)
  }, [selectedWorkspace])

  function handleDrawing(state: boolean) {
    return setDrawing(state)
  }
  return (
    <SliderProvider>
      <InjuryProvider>
        <motion.div
          initial="initial"
          animate="in"
          exit="out"
          variants={animationAppVariants}
          transition={animationAppTransitions}
          className={classes.root}
        >
          {!open && (
            <Button
              className={classes.closeMenu}
              onClick={() => setOpen(!open)}
            >
              <div style={{ paddingLeft: 10 }}>
                <ArrowBackIosIcon fontSize="small" />
              </div>
            </Button>
          )}
          <SideMenu open={open} setOpen={() => setOpen(false)} />
          <div
            className={clsx(classes.container, {
              [classes.contentDrawing]: drawing
            })}
          >
            {drawing ? <Drawing /> : ''}
            <main
              className={clsx(classes.content, {
                [classes.contentDrawing]: drawing
              })}
            >
              {children}
              <CartButton />
              <FloatingMenu handleDrawing={handleDrawing} />
              <DoctorCard
                loading={doctorCardLoading}
                img={doctorCard?.thumb as string}
                name={doctorCard?.name as string}
                crm={doctorCard?.crm as string}
                hospital={doctorCard?.company as string}
              />
            </main>
          </div>
        </motion.div>
      </InjuryProvider>
    </SliderProvider>
  )
}

export default AppLayout
